module.exports = __webpack_public_path__ + "img/title_down.62cfef37.png";